(() => {
  if (window.pmHeaderPointsStarted) return;
  window.pmHeaderPointsStarted = true;
  let busy = false;

  function render(balance) {
    if (!Number.isSafeInteger(balance) || balance < 0) return;
    const next = balance < 450 ? [450, 'Cooler'] : balance < 600 ? [600, 'smoothie'] : balance < 800 ? [800, 'protein bowl'] : balance < 1200 ? [1200, 'soup'] : balance < 1250 ? [1250, 'burrito bowl'] : null;
    const ready = balance >= 450;
    const short = ready ? 'Cooler ready' : `${450 - balance} to a Cooler`;
    const progressText = `${ready ? 'You have enough points for a Cooler. ' : ''}${next ? `${next[0] - balance} more points to your next ${next[1]}.` : 'You have enough points for any of our current product rewards.'}`;
    document.querySelectorAll('[data-pm-reward-progress]').forEach(el => { if (el.textContent !== progressText) el.textContent = progressText; el.hidden = false; });
    document.querySelectorAll('[data-pm-header-points]').forEach(link => {
      const value = link.querySelector('[data-pm-points-value]');
      const text = balance.toLocaleString(document.documentElement.lang || 'en-US');
      if (value.textContent !== text) value.textContent = text;
      link.querySelector('[data-pm-points-fallback]').hidden = true;
      link.querySelector('[data-pm-points-display]').hidden = false;
      link.setAttribute('aria-label', `${text} points available. Open Purefect Rewards`);
      const hint = link.querySelector('[data-pm-header-progress]');
      if (hint) { if (hint.textContent !== short) hint.textContent = short; hint.hidden = false; }
    });
  }

  // Smile's installed Shopify integration populates this native embed on identification.
  function observeEmbed() {
    document.querySelectorAll('[data-pm-points-value]').forEach(value => {
      if (value.dataset.observed) return;
      value.dataset.observed = 'true';
      const read = () => {
        const raw = value.textContent.trim().replace(/,/g, '');
        if (/^\d+$/.test(raw)) render(Number(raw));
      };
      new MutationObserver(read).observe(value, { childList: true, characterData: true, subtree: true });
      read();
    });
  }

  async function refresh() {
    if (busy || document.hidden) return;
    // Feature-detect the methods verified in this store's installed Smile Shopify script.
    // Never initialize a second Smile session or put an API key into the theme.
    const smile = window.Smile;
    if (!smile || typeof smile.customer !== 'object' || !smile.customer) return;
    busy = true;
    try {
      const customer = typeof smile.fetchCustomer === 'function'
        ? await smile.fetchCustomer() : smile.customer;
      render(customer?.points_balance);
      document.dispatchEvent(new CustomEvent('pm:loyalty-customer-updated'));
    } catch (_) {
      // Keep the last confirmed balance; an unavailable balance must not appear as zero.
    } finally {
      busy = false;
    }
  }

  observeEmbed();
  refresh();
  document.addEventListener('smile-ui-loaded', refresh);
  document.addEventListener('shopify:section:load', () => { observeEmbed(); refresh(); });
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('focus', refresh);
  window.addEventListener('pageshow', refresh);
  window.addEventListener('hashchange', refresh);
  // Also covers identification after page load and a redemption made in the panel.
  window.setInterval(refresh, 30000);
})();
